import * as React from 'react'
import * as s from './ThreadListItem.scss'
import { Link } from 'react-router'
import { moment } from 'features/Moment'
import * as sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import { Avatar } from 'components/Avatar'

export interface IThreadListItemProps {
  serviceId: string
  otherNumber: string
  time: string
  contact?: {
    firstName?: string | null
    lastName?: string | null
  } | null
  message: string
}

export const ThreadListItem = ({
  serviceId,
  otherNumber,
  contact,
  message,
  time,
}: IThreadListItemProps) => {
  const name =
    contact &&
    contact.firstName &&
    contact.lastName &&
    [contact.firstName, contact.lastName].join(' ')
  return (
    <Link
      to={`/dashboard/messages/${serviceId}/${otherNumber}`}
      className={cn(s.outer, sLay['layout-row'])}
      activeClassName={s.active}
    >
      <Avatar name={name || '?'} style={{ marginRight: '15px' }} />
      <div className={cn(sLay.flex, sLay['layout-column'])}>
        <div className={cn(sLay.flex, sLay['layout-row'])}>
          <div className={sLay.flex}>{name || otherNumber}</div>
          <div className={s.time}>{moment(time).fromNow()}</div>
        </div>
        <div className={s.message}>{message}</div>
      </div>
    </Link>
  )
}



// WEBPACK FOOTER //
// src/features/Messages/ThreadListItem/ThreadListItem.tsx